<template>
  <div>
    <Header :isHomePage="false" />
    <div class="recipe mt-3">
      <div class="preview-header">
        <h2 class="recipe-title">{{ recipe.name }}</h2>
        <div class="recipe-meta">
          <span class="publication-date">
            {{ formatDate(recipe.datePublication) }}
          </span>
          <div class="recipe-list-tags">
            <span class="badge" v-for="tag in this.categories" :key="tag.id">{{ tag.nom }}</span>
          </div>
        </div>
      </div>
      
      <div v-if="recipe.photoPreview" class="recipe-photo-container">
        <img :src="recipe.photoPreview" class="recipe-photo-preview" />
      </div>
      
      <div class="recipe-content" v-html="recipe.content">
      </div>
    </div>
  </div>
</template>

<script>
import FirebaseDataService from '../services/FirebaseDataService.js';
import Header from '../components/Header.vue'

export default {
  name: 'Recipe',
  components: {
    Header
  },
  data() {
    return {
      recipe: {},
      categories: [],
      allCategories: []
    };
  },
  async mounted() {
    await this.fetchRecipe();
    await this.fetchCategories();
  }, 
  methods: {
    getImagePath(photoName, photoUrl = null) {
      if (!photoName) return '';
      
      // If there's a Firebase URL (new uploads), use it directly
      if (photoUrl && photoUrl.includes('firebase')) {
        return photoUrl;
      }
      
      // Otherwise, try to load from local assets (existing images)
      try {
        return require(`@/assets/images/${photoName}`);
      } catch (error) {
        // If local image doesn't exist and we have a URL, try that
        if (photoUrl) {
          return photoUrl;
        }
        return '';
      }
    },
    async fetchRecipe() {
      try {
        this.recipe = await FirebaseDataService.getRecipe(this.$route.params.id);
        if (this.recipe) {
          this.recipe.photoPreview = this.getImagePath(this.recipe.photoName, this.recipe.photoUrl);
        }
      } catch (error) {
        console.error('Erreur lors du chargement de la recette:', error);
      }
    },
    async fetchCategories() {
      try {
        this.allCategories = await FirebaseDataService.getCategories();
        this.categories = this.recipe.categories.map((categoryId) => {
          return this.allCategories.find(category => category.id === categoryId);
        }).filter(Boolean);
      } catch (error) {
        console.error('Erreur lors du chargement des catégories:', error);
      }
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('fr-CA');
    }
  }
}
</script>

<style>
.recipe-list-tags {
  display: flex;
  flex-wrap: wrap; 
  flex-direction: row;
  justify-content:center;
}

.badge{
  background-color: var(--secondary);
  color: var(--primary);
  margin-right:5px;
  margin-top:3px;
}

.recipe {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

.recipe-content {
  align-self:baseline; 
  padding-top:1rem; 
  padding-bottom:1rem;
  text-align: justify;
}

.recipe-meta {
  color: #666;
}

.preview-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 2px solid var(--light);
  padding-bottom: 20px;
}

.publication-date {
  font-size: 1.1rem;
  margin-bottom: 15px;
  display: inline-block;
}

.recipe-photo-container {
  text-align: center;
  margin: 30px 0;
}

.recipe-photo-preview {
  max-width: 100%;
  max-height: 400px;
  object-fit: cover;
  border-radius: 15px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.2);
}

@media (max-width: 768px) {
  .recipe {
    padding: 20px;
  }
  
  .recipe-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .recipe {
    padding: 15px;
  }
  
  .recipe-title {
    font-size: 1.6rem;
  }
}
</style>
